"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebHubUpdate = void 0;
const react_1 = require("react");
const useAuth_1 = require("./useAuth");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const useWebHubUpdate = (options) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const { currentSession } = (0, useAuth_1.useAuth)();
    const triggerWebHubUpdate = (0, react_1.useCallback)(async (request) => {
        setIsLoading(true);
        setError(null);
        try {
            const session = await currentSession();
            const idToken = session.tokens?.idToken?.toString();
            if (!idToken) {
                throw new Error('No authentication token available');
            }
            const result = await amplifyBootstrap_1.API.post('/update-web-hub', {
                body: request,
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });
            options?.onSuccess?.(result);
            return result;
        }
        catch (err) {
            const wrapped = err instanceof Error ? err : new Error(String(err));
            setError(wrapped);
            options?.onError?.(wrapped);
            throw wrapped;
        }
        finally {
            setIsLoading(false);
        }
    }, [currentSession, options]);
    return {
        triggerWebHubUpdate,
        isLoading,
        error,
    };
};
exports.useWebHubUpdate = useWebHubUpdate;
